import { createContext } from 'react';

export interface AuthGuardContextValue {
  hasScope: (scope: string | string[]) => boolean;
}

export const AuthGuardContext = createContext<AuthGuardContextValue | null>(null);

export default AuthGuardContext;
